/**
 * The two text rules every `.ics` file obeys, in one place.
 *
 * Four copies of these existed (next-email-client's invite builder, the public
 * booking invite in `ui`, the funnel event file in `funnel-components`, and the
 * generated-canvas path) and they did NOT agree: only one normalized CRLF
 * before escaping, so a description pasted from Windows carried a bare carriage
 * return into a property value — legal-looking, and enough to truncate the
 * DESCRIPTION in some clients.
 */

/**
 * RFC 5545 §3.3.11 TEXT escaping.
 *
 * Order matters: backslashes first (or every escape introduced below gets
 * escaped again), and CRLF is normalized before newlines are encoded.
 */
export function escapeIcsText(value: string): string {
  return value
    .replace(/\r\n/g, "\n")
    .replace(/\\/g, "\\\\")
    .replace(/\n/g, "\\n")
    .replace(/;/g, "\\;")
    .replace(/,/g, "\\,");
}

/**
 * RFC 5545 §3.1 line folding: no content line exceeds 75 octets, and a
 * continuation begins with a single space.
 */
export function foldIcsLine(line: string): string {
  if (line.length <= 75) return line;

  const segments: string[] = [];
  let index = 0;
  while (index < line.length) {
    const slice = line.slice(index, index + 75);
    segments.push(index === 0 ? slice : ` ${slice}`);
    index += 75;
  }
  return segments.join("\r\n");
}
